/* ==========================================================================
   Maccs — quick add
   Collection and recommendation cards open this modal. Fetches the product's
   real variants and selling plans, then adds through Envy's cart drawer.
   ========================================================================== */

(function () {
  'use strict';

  var modal = document.querySelector('[data-mx-modal]');
  if (!modal) return;

  document.body.appendChild(modal);

  var planMatch = modal.dataset.mxPlanMatch || '30 days';


  var els = {
    thumb: modal.querySelector('[data-mx-modal-thumb]'),
    name: modal.querySelector('[data-mx-modal-name]'),
    meta: modal.querySelector('[data-mx-modal-meta]'),
    body: modal.querySelector('[data-mx-modal-body]'),
    add: modal.querySelector('[data-mx-modal-add]'),
    dialog: modal.querySelector('.mx-modal__dialog'),
    foot: modal.querySelector('[data-mx-modal-foot]')
  };

  var state = { product: null, variantId: null, planId: '', quantity: 1, lastTrigger: null, busy: false };

  var strings = (window.theme && window.theme.strings) || {};
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- data helpers ----------------------------------------------- */

  function currentVariant() {
    if (!state.product) return null;
    for (var i = 0; i < state.product.variants.length; i++) {
      if (state.product.variants[i].id === state.variantId) return state.product.variants[i];
    }
    return null;
  }

  /* The one selling plan we surface, matched by name. */
  function activePlan(product) {
    var groups = product.selling_plan_groups || [];
    for (var g = 0; g < groups.length; g++) {
      var plans = groups[g].selling_plans || [];
      for (var p = 0; p < plans.length; p++) {
        if ((plans[p].name || '').indexOf(planMatch) !== -1) return plans[p];
      }
    }
    return null;
  }

  function priceFor(variant, planId) {
    if (!variant) return 0;
    if (planId && variant.selling_plan_allocations) {
      for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
        var a = variant.selling_plan_allocations[i];
        if (String(a.selling_plan_id) === String(planId)) return a.price;
      }
    }
    return variant.price;
  }

  /* ---------- rendering --------------------------------------------------- */

  function renderPacks(product) {
    if (product.variants.length < 2) return null;

    var optName = product.options && product.options[0];
    if (optName && typeof optName === 'object') optName = optName.name;

    els.body.appendChild(el('span', 'mx-label', optName || 'Options'));

    var group = el('div', 'mx-options');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', optName || 'Options');

    product.variants.forEach(function (variant) {
      var btn = el('button', 'mx-option');
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', String(variant.id === state.variantId));
      btn.appendChild(el('span', 'mx-option__label', variant.option1 || variant.title));
      btn.appendChild(el('span', 'mx-option__price',
        variant.available ? formatMoney(priceFor(variant, state.planId)) : (strings.soldOut || 'Sold out')));

      if (!variant.available) {
        btn.disabled = true;
      } else {
        btn.addEventListener('click', function () {
          state.variantId = variant.id;
          Array.prototype.forEach.call(group.children, function (c) {
            c.setAttribute('aria-checked', String(c === btn));
          });
          refreshPrices();
        });
      }
      group.appendChild(btn);
    });

    els.body.appendChild(group);
    return group;
  }

  function renderFrequency(product) {
    var plan = activePlan(product);
    if (!plan) return;

    /* Subscribe is listed first and pre-selected, per the design. */
    state.planId = String(plan.id);

    els.body.appendChild(el('span', 'mx-label', 'How often?'));

    var group = el('div', 'mx-choices');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'How often');

    [
      {
        value: String(plan.id),
        title: 'Subscribe & Save 10%',
        sub: 'Ships monthly. Skip or cancel anytime.'
      },
      { value: '', title: 'One-Time Order', sub: 'Baked to order, ships fresh this week.' }
    ].forEach(function (opt) {
      var btn = el('button', 'mx-choice');
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', String(opt.value === state.planId));
      btn.dataset.planId = opt.value;

      btn.appendChild(el('span', 'mx-choice__dot'));
      var text = el('span', 'mx-choice__text');
      text.appendChild(el('span', 'mx-choice__title', opt.title));
      text.appendChild(el('span', 'mx-choice__sub', opt.sub));
      btn.appendChild(text);
      btn.appendChild(el('span', 'mx-choice__price'));

      btn.addEventListener('click', function () {
        state.planId = opt.value;
        Array.prototype.forEach.call(group.children, function (c) {
          c.setAttribute('aria-checked', String(c === btn));
        });
        refreshPrices();
      });

      group.appendChild(btn);
    });

    els.body.appendChild(group);
  }

  function renderQuantity() {
    var row = el('div', 'mx-qty-row');
    row.appendChild(el('span', 'mx-label', 'Quantity'));

    var qty = el('div', 'mx-qty');
    var minus = el('button', 'mx-qty__btn', '\u2212');
    minus.type = 'button';
    var input = el('input', 'mx-qty__input');
    input.type = 'text';
    input.value = '1';
    input.setAttribute('aria-label', 'Quantity');
    var plus = el('button', 'mx-qty__btn', '+');
    plus.type = 'button';

    function set(n) {
      state.quantity = Math.max(1, n);
      input.value = state.quantity;
      refreshPrices();
    }
    minus.addEventListener('click', function () { set(state.quantity - 1); });
    plus.addEventListener('click', function () { set(state.quantity + 1); });
    input.addEventListener('change', function () {
      var n = parseInt(input.value, 10);
      set(isNaN(n) ? 1 : n);
    });

    qty.appendChild(minus); qty.appendChild(input); qty.appendChild(plus);
    row.appendChild(qty);
    els.body.appendChild(row);
  }

  /* Repaint every price in the modal for the current selection. */
    function refreshPrices() {
    var variant = currentVariant();
    if (!variant) return;

    Array.prototype.forEach.call(modal.querySelectorAll('.mx-option'), function (btn, i) {
      var v = state.product.variants[i];
      var target = btn.querySelector('.mx-option__price');
      if (v && v.available && target) target.textContent = formatMoney(priceFor(v, state.planId));
    });

    Array.prototype.forEach.call(modal.querySelectorAll('.mx-choice'), function (btn) {
      var target = btn.querySelector('.mx-choice__price');
      if (target) target.textContent = formatMoney(priceFor(variant, btn.dataset.planId));
    });

    var unit = priceFor(variant, state.planId);

    els.add.innerHTML = '';
    els.add.appendChild(document.createTextNode('Add to Cart \u00b7 '));
    els.add.appendChild(el('span', null, formatMoney(unit * state.quantity)));
    els.add.disabled = false;
  }

  function showError(message) {
    els.body.innerHTML = '';
    els.body.appendChild(el('p', 'mx-modal__error', message));
    els.add.disabled = true;
  }

  /* ---------- open / close ------------------------------------------------ */

  function open(trigger) {
    state.lastTrigger = trigger;
    state.product = null;
    state.variantId = null;
    state.planId = '';
    state.quantity = 1;

    els.name.textContent = trigger.dataset.productTitle || '';
    els.meta.textContent = '';
    els.thumb.src = trigger.dataset.productImage || '';
    els.body.innerHTML = '';
    els.body.appendChild(el('p', 'mx-modal__loading', 'Loading options\u2026'));
    els.add.disabled = true;
    els.add.textContent = 'Add to Cart';

    modal.hidden = false;
    document.body.classList.add('mx-modal-open');
    els.dialog.focus();

    fetch('/products/' + trigger.dataset.productHandle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Not found'); return r.json(); })
      .then(function (product) {
        state.product = product;
        els.name.textContent = product.title;
        if (product.featured_image) els.thumb.src = product.featured_image;

        var usable = product.variants.filter(function (v) { return v.available; });
        state.variantId = (usable[0] || product.variants[0]).id;

        els.body.innerHTML = '';
        var hadPacks = renderPacks(product);
        renderFrequency(product);
        if (!hadPacks) renderQuantity();
        refreshPrices();
      })
      .catch(function () {
        showError('Could not load this product. Please open the product page instead.');
      });
  }

  function close() {
    modal.hidden = true;
    document.body.classList.remove('mx-modal-open');
    if (state.lastTrigger) state.lastTrigger.focus();
  }

  /* ---------- add to cart ------------------------------------------------- */

  function addToCart() {
    var variant = currentVariant();
    if (!variant || state.busy) return;

    state.busy = true;
    els.add.classList.add('is-loading');
    els.add.disabled = true;

    var payload = { id: variant.id, quantity: state.quantity };
    if (state.planId) payload.selling_plan = parseInt(state.planId, 10);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message); });
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.busy = false;
        els.add.classList.remove('is-loading');
        close();
        if (window.MM && typeof window.MM.update_cart_drawer === 'function') window.MM.update_cart_drawer(cart);
        var $ = window.jQuery;
        if ($) { $('#cartSlideoutWrapper').trigger('cart:open'); } else { window.location = '/cart'; }
      })
      .catch(function (err) {
        state.busy = false;
        els.add.classList.remove('is-loading');
        showError(err.message || 'Something went wrong. Please try again.');
      });
  }

  /* ---------- wiring ------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mx-quick-add]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    if (event.target.closest('[data-mx-modal-close]')) { event.preventDefault(); close(); }
  });

  els.add.addEventListener('click', addToCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
})();